import { UserDto } from "core/types";
import queryString from "query-string";

import { AxiosInstance } from "@bps/http-client";

import {
  UserPreferenceArgs,
  UserPreferenceDto,
  UserPreferenceModel
} from "./user.dtos";
import { IUserGateway } from "./user.gateway.interface";

export class UserGateway implements IUserGateway {
  constructor(private api: AxiosInstance) {}

  public getUserPreferences = async (
    args: UserPreferenceArgs
  ): Promise<UserPreferenceModel[]> => {
    const { stringify } = queryString;
    const data = (
      await this.api.get<UserPreferenceDto[]>(
        `userpreferences?${stringify(args)}`
      )
    ).data;
    return data.map(x => new UserPreferenceModel(x));
  };

  public getCurrentUser = async (): Promise<UserDto> =>
    (await this.api.get<UserDto>("users/me")).data;
}
